import {
  IRecord_Project,
} from '@kaidam/fc-shared/src/types/schema/project'

// The apps the v2 app at /v2 covers: Support, Reporting, Payments
// (coconut_ppc_payments) and Network/Audit Trail (rbac). Operations Hub
// (knowledgebase) counts as covered although v2 no longer links to it: it
// stays reachable at /operationshub by URL, and leaving it out would keep
// every brand on the legacy dashboard.
export const V2_APP_NAMESPACES = ['knowledgebase', 'support', 'reporting', 'coconut_ppc_payments', 'rbac']

// A project is handed to v2 only when v2 offers every app it enables and it
// has no external links, which v2 does not show. Anything else (CRM, Email,
// NoPress...) keeps the legacy pages so its users can still reach them.
export const v2CoversProject = (project: IRecord_Project): boolean => {
  const apps = project.meta?.apps || []
  const externalLinks = project.meta?.external_links || []
  return externalLinks.length == 0 && apps.every(app => V2_APP_NAMESPACES.indexOf(app.namespace) >= 0)
}
